import { Observable } from 'rxjs';
import { TransferProcess } from '../models/transfer-process.model';

export abstract class TransferProcessApiPort {
  abstract getTransferProcesses(): Observable<TransferProcess[]>;
}
